<header class="bg-new-dark w-full p-5 lg:py-4 border-solid border-b border-[#262626] sticky top-0 z-50">
  <div class="container flex items-center justify-between flex-row-reverse lg:flex-row">
    <div class="flex lg:gap-12">
      <a routerLink="/">
        <img src="assets/images/logo.png" alt="Bit.ir Logo" class="w-[134px]">
      </a>

      <div class="hidden lg:flex" *ngIf="appService.isDesktop$ | async">
        <ng-container *ngTemplateOutlet="navigation"></ng-container>
      </div>
    </div>

    <div class="flex items-center gap-3 lg:hidden">

      <div [class.active]="menuToggle" class="icon-lines" (click)="menuToggle = !menuToggle">
        <span class="line line1"></span>
        <span class="line line2"></span>
        <span class="line line3"></span>
      </div>

      <svg width="4" height="22" viewBox="0 0 4 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_130_2232)">
          <path d="M8.5 1.25L8.5 20.75M2 1.25L2 20.75M-4.5 1.25L-4.5 20.75" stroke="white" stroke-width="2.5"
            stroke-linecap="round" stroke-linejoin="round" />
        </g>
        <defs>
          <clipPath id="clip0_130_2232">
            <rect width="22" height="4" fill="white" transform="translate(4) rotate(90)" />
          </clipPath>
        </defs>
      </svg>

      <ng-container *ngTemplateOutlet="changeLang"></ng-container>


    </div>

    <div class="hidden lg:flex gap-[10px] items-center">

      <p class="transition-colors hover:text-primary">021-91090006 <span class="!text-white">|</span> </p>

      <ng-container *ngTemplateOutlet="changeLang">
      </ng-container>

      <ng-container *ngTemplateOutlet="authLinks"></ng-container>
    </div>
  </div>

  <div class="{{ menuToggle ? 'fixed' : 'hidden' }} transition-all top-[74px] left-0 z-10 w-full h-screen bg-new-dark text-base"
    *ngIf="!(appService.isDesktop$ | async) && menuToggle" @fade>
    <div class="flex py-8 px-5 flex-col gap-7">
      <ng-container *ngTemplateOutlet="navigation"></ng-container>

      <div class="flex items-center gap-4">
        <ng-container *ngTemplateOutlet="authLinks"></ng-container>
      </div>
    </div>
  </div>
</header>




<ng-template #authLinks>
  <a href="https://app.bit.ir/sign-in"
    class="bg-transparent py-1 px w-[85px] text-center rounded-md text-primary border border-solid border-primary grow lg:grow-0">ورود</a>
  <a href="https://app.bit.ir/sign-up"
    class="bg-primary hover:bg-primary-dark transition-colors py-1 px w-[85px] text-center rounded-md text-black border border-solid border-primary grow lg:grow-0">ثبت‌نام</a>
</ng-template>

<ng-template #navigation>
  <nav class="font-medium text-white flex lg:flex-row flex-col gap-7 items-start lg:items-center">
    <a routerLink="/">صفحه اصلی</a>
    <button cdkOverlayOrigin #trigger="cdkOverlayOrigin" (click)="isCryptoListOpen = !isCryptoListOpen"
      class="hidden lg:flex gap-2 items-center">
      <span>
        قیمت
        ارزهای دیجیتال
      </span>
      <svg width="10" height="7" viewBox="0 0 10 7" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M4.68847 6.48847L0.118841 1.69251C0.0425558 1.61249 0 1.50617 0 1.39561C0 1.28506 0.0425558 1.17874 0.118841 1.09872L0.124004 1.09355C0.160986 1.05463 0.2055 1.02363 0.254839 1.00245C0.304178 0.981265 0.357311 0.970342 0.411005 0.970342C0.464698 0.970342 0.517831 0.981265 0.56717 1.00245C0.616509 1.02363 0.661024 1.05463 0.698005 1.09355L5.00086 5.60983L9.30199 1.09355C9.33898 1.05463 9.38349 1.02363 9.43283 1.00245C9.48217 0.981265 9.5353 0.970342 9.58899 0.970342C9.64269 0.970342 9.69582 0.981265 9.74516 1.00245C9.7945 1.02363 9.83901 1.05463 9.87599 1.09355L9.88116 1.09872C9.95744 1.17874 10 1.28506 10 1.39561C10 1.50617 9.95744 1.61249 9.88116 1.69251L5.31153 6.48847C5.27134 6.53065 5.22301 6.56423 5.16946 6.58717C5.11591 6.61012 5.05826 6.62195 5 6.62195C4.94174 6.62195 4.88409 6.61012 4.83054 6.58717C4.77699 6.56423 4.72866 6.53065 4.68847 6.48847Z"
          fill="white" />
      </svg>
    </button>
    <a href="/coins" class="inline-block lg:hidden">قیمت ارزهای دیجیتال</a>
    <a routerLink="/heatmap">نقشه بازار</a>
    <a href="#tutorial">راهنما</a>
    <a href="/blog">بلاگ</a>
    <a href="#" (click)="openSupport($event)">پشتیبانی</a>
    <a href="https://festival.bit.ir/" class="text-primary hover:text-white transition-colors flex">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M11 14V22H7C6.20435 22 5.44129 21.6839 4.87868 21.1213C4.31607 20.5587 4 19.7956 4 19V15C4 14.7348 4.10536 14.4804 4.29289 14.2929C4.48043 14.1053 4.73478 14 5 14H11ZM19 14C19.2652 14 19.5196 14.1053 19.7071 14.2929C19.8946 14.4804 20 14.7348 20 15V19C20 19.7956 19.6839 20.5587 19.1213 21.1213C18.5587 21.6839 17.7956 22 17 22H13V14H19ZM16.5 1.99998C17.0905 1.99985 17.6715 2.14914 18.1888 2.43394C18.706 2.71875 19.1429 3.1298 19.4586 3.62884C19.7743 4.12788 19.9586 4.69869 19.9943 5.28812C20.03 5.87755 19.9161 6.46644 19.663 6.99998H20C20.5304 6.99998 21.0391 7.21069 21.4142 7.58576C21.7893 7.96084 22 8.46954 22 8.99998V9.99998C22 10.5304 21.7893 11.0391 21.4142 11.4142C21.0391 11.7893 20.5304 12 20 12H13V6.99998H11V12H4C3.46957 12 2.96086 11.7893 2.58579 11.4142C2.21071 11.0391 2 10.5304 2 9.99998V8.99998C2 8.46954 2.21071 7.96084 2.58579 7.58576C2.96086 7.21069 3.46957 6.99998 4 6.99998H4.337C4.11444 6.53129 3.99931 6.01883 4 5.49998C4 3.56698 5.567 1.99998 7.483 1.99998C9.238 1.96998 10.795 3.09198 11.864 4.93398L12 5.17698C13.033 3.26298 14.56 2.06298 16.291 2.00198L16.5 1.99998ZM7.5 3.99998C7.10218 3.99998 6.72064 4.15801 6.43934 4.43932C6.15804 4.72062 6 5.10215 6 5.49998C6 5.8978 6.15804 6.27933 6.43934 6.56064C6.72064 6.84194 7.10218 6.99998 7.5 6.99998H10.643C9.902 5.09498 8.694 3.97998 7.5 3.99998ZM16.483 3.99998C15.303 3.97998 14.098 5.09598 13.357 6.99998H16.5C16.8978 6.99772 17.2785 6.83752 17.5582 6.55463C17.8379 6.27173 17.9938 5.8893 17.9915 5.49148C17.9892 5.09365 17.829 4.71302 17.5462 4.43331C17.2633 4.1536 16.8808 3.99772 16.483 3.99998Z"
          fill="currentColor" />
      </svg>
      <span>جشنواره</span>
    </a>
  </nav>

  <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="trigger" [cdkConnectedOverlayOpen]="isCryptoListOpen">
    <ul class="bg-[#111111] rounded-sm py-7 px-3 flex flex-col gap-3 min-w-[200px]" @fade (appClickOutside)="handleCryptoListClose()">
      <li *ngFor="let item of (markets$ | async)!.slice(0, 6)" class="">
        <a href="https://app.bit.ir/trade/{{item.id}}/IRR" target="_blank"
          class="flex text-sm gap-3"><span>{{item.name}} | {{ item.id }}</span> <img class="w-[20px] h-[20px]"
            [src]="item.iconPath" [alt]="item.id + 'icon'"></a>
      </li>
      <li><a (click)="isCryptoListOpen = false" class="text-sm" routerLink="/coins">مشاهده همه</a></li>
    </ul>
  </ng-template>
</ng-template>


<ng-template #changeLang>
  <div (click)="isLanguageMenuVisible = !isLanguageMenuVisible" class="relative cursor-pointer">
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10 20C4.477 20 0 15.523 0 10C0 4.477 4.477 0 10 0C15.523 0 20 4.477 20 10C20 15.523 15.523 20 10 20ZM7.71 17.667C6.72341 15.5743 6.15187 13.3102 6.027 11H2.062C2.25659 12.5389 2.89392 13.9882 3.89657 15.1717C4.89922 16.3552 6.22401 17.2221 7.71 17.667ZM8.03 11C8.181 13.439 8.878 15.73 10 17.752C11.1523 15.6766 11.8254 13.3695 11.97 11H8.03ZM17.938 11H13.973C13.8481 13.3102 13.2766 15.5743 12.29 17.667C13.776 17.2221 15.1008 16.3552 16.1034 15.1717C17.1061 13.9882 17.7434 12.5389 17.938 11ZM2.062 9H6.027C6.15187 6.68979 6.72341 4.42569 7.71 2.333C6.22401 2.77788 4.89922 3.64475 3.89657 4.8283C2.89392 6.01184 2.25659 7.4611 2.062 9ZM8.031 9H11.969C11.8248 6.6306 11.152 4.32353 10 2.248C8.84768 4.32345 8.17456 6.63052 8.03 9M12.289 2.333C13.2759 4.42562 13.8478 6.68972 13.973 9H17.938C17.7434 7.4611 17.1061 6.01184 16.1034 4.8283C15.1008 3.64475 13.776 2.77788 12.29 2.333"
        fill="white" />
    </svg>

    <div *ngIf="isLanguageMenuVisible" class="language-selector" @fade>
      <div class="flex">
        <a class="flex gap-2" href="https://bit.ir/fa" (click)="$event.stopImmediatePropagation()">
          <img src="assets/images/flags/iran.png" width="20" height="20" alt="persian">
          <p class="text-sm"><strong i18n>فارسی</strong></p>
        </a>
      </div>
      <div class="flex my-2">
        <svg width="96" height="2" viewBox="0 0 96 2" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M96 1H0" stroke="url(#paint0_radial_1987_14772)" />
          <defs>
            <radialGradient id="paint0_radial_1987_14772" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse"
              gradientTransform="translate(48 1.5) rotate(90) scale(0.5 48)">
              <stop stop-color="white" />
              <stop offset="1" stop-opacity="0" />
              <stop offset="1" stop-color="white" stop-opacity="0" />
            </radialGradient>
          </defs>
        </svg>
      </div>
      <div class="flex">
        <a class="flex gap-2" href="https://bit.ir/en" (click)="$event.stopImmediatePropagation()">
          <img class="web" src="assets/images/flags/england.webp" width="20" height="20" alt="english">
          <p class="text-sm"><strong i18n>انگلیسی</strong></p>
        </a>
      </div>
    </div>
  </div>
</ng-template>